import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import {
  FormViewService,
  SubmissionService,
  IntegrationMappingService,
} from '@xilo-mono/form-contracts';
import { changeInputCSS } from '../helper/form';

@Component({
  selector: 'xilo-mono-form-viewer-company-name',
  templateUrl: './company-name.component.html',
  styleUrls: [
    '../../form-viewer.component.scss',
    './company-name.component.scss',
  ],
})
export class CustomCompanyNameComponent extends FieldType {
  isInvalid = false;
  errorMessage = false;
  changeInputCSS = changeInputCSS;

  constructor(
    private integrationMappingService: IntegrationMappingService,
    public formViewService: FormViewService,
    private submissionService: SubmissionService
  ) {
    super();
  }

  updateMetadata(event: any) {
    try {
      const target = event.target as HTMLInputElement;
  
      if (target?.value) {
        const trimmedValue = target.value.trim();
        this.formControl.setValue(trimmedValue);
  
        this.submissionService.onUpdateMetadata(
          {
            key: 'companyName',
            value: target.value,
          },
        this.field
        );
        if (this.to.className !== 'xilo-input') {
          this.formViewService.updateForm.next(true);
        }
        this.integrationMappingService.initDataPull(
          this.to?.pullDataTrigger,
          this.to?.dataPullMappingId,
          this.field?.parent?.parent?.templateOptions?.subIndex
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  getError() {
    return 'Invalid response';
  }
}
